<template>
  <a-layout :style="{background: 'linear-gradient(147.39deg, #FF942D -2.73%, #F84273 100%)'}">
    <a-layout-content :style="{backgroundImage: 'none'}">
      <div :class="$style.header">
        <div :class="$style.logo">
          <router-link to="/">
            <img src="resources/images/logo.png" alt="GoDate" />
          </router-link>
        </div>
        <nav :class="$style.navigation">
          <!-- <ul :class="$style.navigationItems">
            <li>
              <a href="javascript: void(0);">&larr; Back</a>
            </li>
            <li>
              <a :class="$style.navigationActive" href="javascript: void(0);">Login</a>
            </li>
            <li>
              <a href="javascript: void(0);">About</a>
            </li>
            <li>
              <a href="javascript: void(0);">Support</a>
            </li>
          </ul> -->
        </nav>
      </div>
      <div :class="[$style.content, settings.isMobileView?$style.mobile:'']">
        <router-view/>
      </div>
      <div :class="[$style.footer, 'text-center']">
        <p>&copy; 2019 GoDate, a product of GoStream Jsc. All rights reserved.</p>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LoginLayout',
  data: function () {
    return {
      backgroundEnabled: true,
      backgroundNumber: 1,
    }
  },
  computed: mapState(['settings']),
  methods: {
    changeBackground() {
      this.backgroundEnabled = true
      if (this.backgroundNumber === 5) {
        this.backgroundNumber = 1
      } else {
        this.backgroundNumber += 1
      }
    },
    toggleBackground() {
      this.backgroundEnabled = !this.backgroundEnabled
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
